import React, { useCallback } from 'react';
import styled from 'styled-components/macro';

import { Flavor } from '../../../../common/types';
import Scroll from '../../../../common/components/svg/Scroll';
import { sections, viewport } from '../../../../common/config';
import useFlavorStore from '../../../../common/store/useFlavorStore';

import useIcon from './useIcon';

const Wrapper = styled.div`
  position: relative;
  height: ${sections.height.landing}vh;
  margin: 0 15%;

  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled.h2(({ $flavor }: { $flavor: Flavor }) => `
  margin: 10rem 0;
  font-size: 45rem;
  font-family: 'Dancing Script', cursive;

  @media screen and (min-width: ${viewport.md}) { font-size: 55rem }
  @media screen and (min-width: ${viewport.lg}) { font-size: 65rem }

  span {
    color: var(--${$flavor});
  }
`);

const Description = styled.p`
  max-width: 700rem;
  margin: 10rem 0;
  font-size: 20rem;

  @media screen and (min-width: ${viewport.md}) { 
    font-size: 23rem;
    line-height: 30rem;
  }

  @media screen and (min-width: ${viewport.lg}) { 
    font-size: 26rem;
    line-height: 36rem;
  }
`;

const ScrollContainer = styled.div(({ $visible }: { $visible: boolean }) => `
  position: absolute;
  bottom: 10vh;

  opacity: ${$visible ? "1" : "0"};
  transition: 0.25s opacity;

  @media screen and (min-width: ${viewport.sm}) { bottom: 6vh }

  p {
    margin: 4rem 0;
    font-size: 14rem;
    color: #aaa;
  }
`);

const Joy = () => {
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));
  const visible = useIcon();

  return (
    <Wrapper>
      <Title $flavor={flavor}>The joy of <span>simple pleasure</span></Title>

      <Description>
        Since the launch of Somersby in 2008, we like to think we have taken the world by storm.
        We went from 1 to over 50 markets in less than 10 years, and despite our short history,
        have become the biggest international cider brand in the universe.
      </Description>

      <ScrollContainer $visible={visible}>
        <p>Scroll to discover</p>
        <Scroll color="#aaa" />
      </ScrollContainer>
    </Wrapper>
  );
}

export default Joy;